import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import './legend-style.css'
import './leaflet-measure.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { QueryClient, QueryClientProvider } from 'react-query'
import { ReactQueryDevtools } from 'react-query/devtools'

import { AuthProvider } from '@graniot/common/context/AuthContext'

import i18n from './i18n' // do not remove

const queryClient = new QueryClient()

ReactDOM.render(
    <React.StrictMode>
        {/* Provide the structures to communicate with backend */}
        <QueryClientProvider client={queryClient}>
            {/* Provide all data on user and auth token */}
            <AuthProvider>
                <App />
            </AuthProvider>

            {!process.env.REACT_APP_DEBUG && <ReactQueryDevtools initialIsOpen />}
        </QueryClientProvider>
    </React.StrictMode>,
    document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
